var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"lm-banner"},_vm._l((_vm.list),function(item,i){return _c('li',{staticClass:"lm-banner_item"},[_c('div',{staticClass:"lm-banner_title"},[_vm._v(_vm._s(item.title))]),_c('div',{staticClass:"lm-banner_intro"},[_vm._v(_vm._s(item.intro))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }